/**
* DevExpress HTML/JS Reporting (designer\bands\metadata\xrVerticalDetailBandMetaData.js)
* Version:  24.1.7
* Build date: Oct 28, 2024
* Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import { sortFields } from './xrDetailBandMetaData';
import { bandLayout, commonVerticalBandProperties } from './xrVerticalBandMetaData';
export const verticalDetailBandSerializationInfo = [bandLayout, sortFields].concat(commonVerticalBandProperties);
export const popularPropertiesVerticalDetailBand = ['sortFields', 'bandLayout'];
